import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FederationComponent } from './federation.component';


const routes: Routes = [
  { 
      path: '', component: FederationComponent,
      children: [
        { path: 'federation', component: FederationComponent },
      ]
  }
];

@NgModule({
  imports: [
      RouterModule.forChild(routes)
    ],
  exports: [
      RouterModule
    ]
})
export class FederationRoutingModule { }
